import { useEffect, useState, useCallback } from 'react';

export default function useStepper(totalSteps) {
  const [activeStep, setActiveStep] = useState(0);
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [isLastStep, setIsLastStep] = useState(false);

  const nextStep = useCallback(() => {
    setActiveStep((prev) => (prev < totalSteps ? prev + 1 : prev));
  }, [totalSteps]);

  const previousStep = useCallback(() => {
    setActiveStep((prev) => (prev > 0 ? prev - 1 : prev));
  }, []);

  const gotoLastStep = () => {
    setActiveStep(totalSteps - 1);
  };

  const gotoFirstStep = () => {
    setActiveStep(0);
  };

  const changeStep = (value) => {
    if (value >= 0 && value < totalSteps) {
      setActiveStep(value);
    } else {
      throw new Error('Value is out of range to total steps');
    }
  };

  useEffect(() => {
    if (activeStep === 0) {
      setIsFirstStep(true);
      setIsLastStep(false);
    } else if (activeStep === totalSteps - 1) {
      setIsFirstStep(false);
      setIsLastStep(true);
    } else {
      setIsFirstStep(false);
      setIsLastStep(false);
    }
  }, [activeStep, totalSteps]);

  return {
    activeStep,
    isFirstStep,
    isLastStep,
    changeStep,
    nextStep,
    previousStep,
    gotoFirstStep,
    gotoLastStep,
  };
}
